import client from './client';

export const servicesApi = {
  list: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return client.get(`/services${query ? `?${query}` : ''}`, { auth: false });
  },
  get: (id) => client.get(`/services/${id}`, { auth: false }),
  categories: (univers) =>
    client.get(`/service-categories${univers ? `?univers=${univers}` : ''}`, { auth: false }),

  // Back Office
  create: (data) => client.post('/services', data),
  update: (id, data) => client.put(`/services/${id}`, data),
  remove: (id) => client.delete(`/services/${id}`),

  // Back Office — catégories
  createCategory: (data) => client.post('/admin/service-categories', data),
  updateCategory: (id, data) => client.put(`/admin/service-categories/${id}`, data),
  removeCategory: (id) => client.delete(`/admin/service-categories/${id}`),
};
